import { Box, Container } from '@mui/material';
import { useParams } from 'react-router-dom';
import { HUB_SECTION_META } from '../seo/staticPageSeoMeta';
import { KC_COLORS } from '../../pages/knowledge-center/theme';
import { KcIcon } from '../../pages/knowledge-center/components/KcIcon';
import { useHubSearchInput } from '../../pages/new/layout/HubSearchContext';

const PLACEHOLDERS = {
  all: 'Search blogs, news, podcasts, events, and use cases',
  blogs: 'Search blog posts',
  news: 'Search news and announcements',
  podcasts: 'Search podcast episodes',
  events: 'Search events and webinars',
  usecases: 'Search use cases',
};

export const BlogsHero = () => {
  const { section } = useParams();
  const meta = HUB_SECTION_META[section] || HUB_SECTION_META.all;
  const [query, setQuery] = useHubSearchInput();

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <Box className="w-full pt-28 md:pt-32 pb-12 md:pb-14 bg-[#0D131E]">
      <Container maxWidth="lg">
        <Box className="w-full py-6 md:py-10 text-white">
          <h1
            className="m-0 font-medium tracking-normal"
            style={{
              fontSize: 'clamp(32px, 5vw, 56px)',
              lineHeight: 1.15,
            }}
          >
            {meta.h1}
          </h1>
          <p className="m-0 mt-5 md:mt-7 max-w-3xl text-[16px] leading-[28px] md:leading-[31px] font-normal text-white/85">
            {meta.heroDescription}
          </p>

          <form onSubmit={handleSubmit} className="mt-8 md:mt-10 flex justify-center">
            <label htmlFor="hub-search" className="sr-only">
              Search insights
            </label>
            <div className="relative w-full max-w-2xl mx-auto">
              <input
                id="hub-search"
                type="search"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder={PLACEHOLDERS[section] || PLACEHOLDERS.all}
                className="w-full h-14 md:h-[60px] rounded-full bg-white pl-6 md:pl-7 pr-14 md:pr-16 shadow-[0_10px_30px_rgba(0,0,0,0.18)] outline-none focus:ring-2"
                style={{
                  color: KC_COLORS.primaryNavy,
                  fontSize: '15px',
                  lineHeight: '22px',
                  '--tw-ring-color': KC_COLORS.teal,
                }}
              />
              <button
                type="submit"
                aria-label="Search"
                className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 md:w-11 md:h-11 rounded-full text-white flex items-center justify-center transition-opacity hover:opacity-90"
                style={{ backgroundColor: KC_COLORS.teal }}
              >
                <KcIcon name="search" fontSize="small" />
              </button>
            </div>
          </form>
        </Box>
      </Container>
    </Box>
  );
};
